import { useAuthStore } from '@/store/authStore'

export function useIsAdmin() {
  return useAuthStore((state) => state.user?.role === 'ADMIN')
}
